export default __webpack_public_path__ + "static/media/ls-bg.5bfcba77.png";